import { useTrialStatus, isPro, isTrialActive, isTrialExpired, getTrialDaysRemaining } from './useTrialStatus';

interface PlanFeatures {
  isPro: boolean;
  isTrial: boolean;
  isTrialExpired: boolean;
  trialDaysUsed: number;
  trialDaysRemaining: number;
  // Com o modelo Trial->Pro, todos os recursos são liberados para quem tem acesso.
  // O bloqueio total é feito no ProtectedRoute via TrialExpiredPaywall.
  // Estas flags existem apenas para features exclusivamente Pro (ex: export).
  canExport: boolean;
  isLoading: boolean;
}

export function usePlan(): PlanFeatures {
  const { data: trialStatus, isLoading } = useTrialStatus();

  const userIsPro = isPro(trialStatus);
  const userIsTrialActive = isTrialActive(trialStatus);
  const userIsTrialExpired = isTrialExpired(trialStatus);
  const trialDaysUsed = trialStatus?.trial_days_used || 0;
  const trialDaysRemaining = getTrialDaysRemaining(trialDaysUsed);

  return {
    isPro: userIsPro,
    isTrial: userIsTrialActive,
    isTrialExpired: userIsTrialExpired,
    trialDaysUsed,
    trialDaysRemaining,
    // Export PDF/Excel é a única feature exclusiva Pro durante o trial
    canExport: userIsPro,
    isLoading,
  };
}
